// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__17ncg","row":"Option_row__3Bsv0"};